
import Vue from 'vue';

export default Vue.extend({
	name: 'InfoSection',

	props: {
		currentReviews: {
			type: Object,
			default: () => ({})
		},

		locationSite: {
			type: Object,
			default: () => ({})
		},

		titleName: {
			type: [String, Object],
			default: ''
		},

		showLink: {
			type: [Boolean, Object],
			default: false
		}
	},

	computed: {
		isMobile(): boolean {
			return this.$vuetify.breakpoint.smAndDown;
		}
	}
});
